module.exports = "<div class=\"content\">\n  <div *ngIf=\"loading\">Loading...</div>\n  <div ace-editor\n    [text]=\"code\"\n    [mode]=\"type\"\n    [autoUpdateContent]=\"false\"\n    [options]=\"options\"\n    class=\"editor\"\n    [readOnly]=\"readOnly\"\n    theme=\"tomorrow_night\"\n    *ngIf=\"!loading\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/code-example/code-example.component.html
// module id = ./src/app/code-example/code-example.component.html
// module chunks = main